jQuery(document).ready(function($) {

  $('.section-product, .list-news, .list-important, #section-catalog, #section-faq').on('inview', function(event, isInView) {
    if (isInView) {
      $(this).addClass('animate__animated animate__fadeInUp');
    } 
  });


$('#section-shoplist, #section-distributorship').on('inview', function(event, isInView) {
    if (isInView) {
      $(this).find('.btn-box').addClass('animate__animated animate__fadeInUp');
    } 
  });
  
$('#section-moortight').on('inview', function(event, isInView) {
    if (isInView) {
      $(this).find('.wp-bootstrap-blocks-row').addClass('animate__animated animate__fadeInUp');
    } 
  });



if($('.slider-for').length){

    $('.section-product .wp-block-gallery').removeClass('wp-block-gallery').removeClass('columns-3').addClass('product-gallery').removeClass('is-layout-flex');

    





   if($('.slide-01').length){

      $('.slide-01 .slider-for').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: '.slide-01 .slider-nav'
      });
  
      $('.slide-01 .slider-nav').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          asNavFor: '.slide-01 .slider-for',
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 576,
                slidesToShow: 3
              }
          ]
         });
        }
  if($('.slide-02').length){

          $('.slide-02 .slider-for').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              fade: true,
              asNavFor: '.slide-02 .slider-nav'
          });
      
          $('.slide-02 .slider-nav').slick({
              slidesToShow: 5,
              slidesToScroll: 1,
              asNavFor: '.slide-02 .slider-for',
              focusOnSelect: true,
              responsive: [
                {
                  breakpoint: 576,
                    slidesToShow: 3
                  }
              ]
             });
            }



        else {
          $('.product-gallery.slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.slider-nav'
        });
    
        $('.product-gallery.slider-nav').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.slider-for',
            focusOnSelect: true,
            responsive: [
              {
                breakpoint: 576,
                  slidesToShow: 3
                }
            ]
           });
        }
}
      

if($('.slide-products').length){
        $('.slide-products').slick(
          {
            infinite: true,
            dots: true,
            autoplay: true,

          }
        );
        }


if($('.row-masonry').length){

         $('.row-masonry').masonry({
            itemSelector: '.col-lg-4',
          });
        }
    
        
  
  if($('.slide-top-products').length){
          $('.slide-top-products').slick(
            {
              slidesToShow: 3,
              responsive: [
            {
              breakpoint: 992,
              settings: {
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 2
              }
            },
            {
              breakpoint: 576,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1
              }
            }
          ]
            }
          );
          }





    $('#main-nav .nav-link').on("click", function() {
      $(".nav-link").not(this).next().hide();
      $(this).next().slideToggle();
      });
      return false;




});




jQuery(function($) {
  $(".guarantee-form .card-product").hide();
  function showNextCard(currentCardId, nextCardId) {
    $(`#${currentCardId} input[type="text"]`).on('input', function() {
      if ($(this).val().trim() !== "") {
        $(`#${nextCardId}`).show();
      } else {
        $(`#${nextCardId}`).hide();
      }
    });
  }

  function checkInputsAndShowCards() {
    let cardsToShow = [];

    $('.guarantee-form .card-product').each(function() {
      const cardId = $(this).attr('id');
      const inputField = $(this).find('input[type="text"]');
      if (inputField.length > 0 && inputField.val().trim() !== "") {
        cardsToShow.push(cardId);
      }
    });

    cardsToShow.forEach((cardId, index) => {
      $(`#${cardId}`).show();
      if (index < cardsToShow.length - 1) {
        showNextCard(cardId, cardsToShow[index + 1]);
      }
    });
  }

  // 最初の項目を初期表示
  $('.guarantee-form #product-1').show();

  // 各カードにイベントを設定
  showNextCard('product-1', 'product-2');
  showNextCard('product-2', 'product-3');
  showNextCard('product-3', 'product-4');
  showNextCard('product-4', 'product-5');

  // ページ読み込み時に入力があったカードを表示
  checkInputsAndShowCards();
});